export const IS_DEV = process.env.NODE_ENV === 'development'
export const HOST_URL = IS_DEV ? `http://${window.location.hostname}:8080` : ''
export const MESSAGE_DURATION = 1
export const LANDING_MOVIE_LOCATION = "https://s3.eu-central-1.amazonaws.com/aft-prd-images/images/netto_planner_480.mp4"